/** Clu's moves, from the Clu Motion Set. A greeting plays one at random. */
export const CLU_MOVES = ['thinking', 'pondering', 'nod', 'salute'] as const;

export type CluMove = (typeof CLU_MOVES)[number];
